import isNil from 'lodash.isnil';

export default val =>
    isNil(val) || val === '';



/** WEBPACK FOOTER **
 ** ./src/utils/notSet.js
 **/